import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "400px",
    maxWidth: "490px",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    borderRadius: "10px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.tertiary,
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    position: "relative",
    padding: "8%",
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: "25px",
    fontWeight: "700",
  },
  closeIcon: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },
  displayFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },

  cardContentDiv2: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },

  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    width: "170px",
    height: "45px",
    padding: "0px 8px",
    borderRadius: "10px",
  },

  labelText: {
    display: "block",
    borderRadius: "5px",
    cursor: "pointer",
    textAlign: "center",
  },

  cardContentInput1: {
    padding: "0.2px 6px",
  },

  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    width: "100%",
    textTransform: "none",
    padding: "6px",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    padding: "0",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },
  defaultButton: {
    color: theme.palette.text.tertiary,
    minWidth: 0,
    padding: "0px",
  },
  selectedButton: {
    color: theme.palette.text.primary,
    minWidth: 0,
    padding: "0px",
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "0px",
  },
}));

export default useStyles;
